<span class="cursor-pointer" (click)="clicked()">
  <ng-content></ng-content>@if (!active) {
  <i class="fa fa-sort"></i>
  }@if (active && !sortOrder) {
  <i class="fa fa-sort-down"></i>
  }@if (active && sortOrder) {
  <i class="fa fa-sort-up"></i>
}</span>